import { render } from "./CraChecklistConfig.vue?vue&type=template&id=143d23da&scoped=true"
import script from "./CraChecklistConfig.js?vue&type=script&lang=js"
export * from "./CraChecklistConfig.js?vue&type=script&lang=js"

import "./CraChecklistConfig.vue?vue&type=style&index=0&id=143d23da&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-143d23da"]])

export default __exports__